// extracted by mini-css-extract-plugin
module.exports = {"wrapperIcon":"WrapperIcon_wrapperIcon__zmt5S"};